import { put } from "redux-saga/effects";
import { AuthService, MigrateGuestToUserResponse } from "../../../services/auth";

import { MigrateGuestToUserRequestActionType } from "../types";
import { getCurrentUserRequest, migrateUserSuccess } from "../actionCreators";

export function* migrateUserSaga({ payload: { userId, userRefreshToken } }: MigrateGuestToUserRequestActionType) {
    if (userId) {
        try {
            const migration: MigrateGuestToUserResponse = yield AuthService.migrateGuest({
                userId: userId,
                userRefreshToken,
            });
            if (migration.data.success) {
                yield put(migrateUserSuccess({ userId: userId, userRefreshToken }));
                yield put(getCurrentUserRequest({}));
            } else {
                throw Error("Migration Error");
            }
        } catch (error) {
            console.log("Error in migrateUserSaga", error);
            // if (axios.isAxiosError(error))
            //     yield put(
            //         initUserFailure({ errorType: IErrorType.AXIOS, data: error.response ? error.response.data : null }),
            //     );
            // else yield put(initUserFailure({ errorType: IErrorType.NATIVE, data: error }));
            // return null;
        }
    }
}
